/* eslint no-eval: 0 */
import { SET_SCRIPTS } from './actionTypes';

// Selectors
import { getScript } from 'store/reducers/scripts/selectors';

export const setScripts = scripts => async (dispatch, getState) => {
  if (scripts && scripts.scripts) {
    dispatch({
      type: SET_SCRIPTS,
      payload: scripts.scripts
    });
  }
};

export const execScript = scriptName => async (dispatch, getState) => {
  if (typeof scriptName === 'string' && Boolean(scriptName)) {
    const script = getScript(getState())(scriptName);
    /* eslint-disable no-console */
    try {
      console.log(`starting ${scriptName}`);
      /* eslint-disable no-new-func */
      console.warn(script);
      new Function(script)();
      console.log(`ending ${scriptName}`);
    } catch (e) {
      console.error(e);
      console.error(`error on ${scriptName} skipping`);
    }
    /* eslint-enable no-console */
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/scripts/actions.js